import React from 'react'
import UserAvatar from '../../../../UserAvatar/index'

export interface ProfileAvatarRingProps {
  avatarUrl: string
  displayName: string
  className?: string
}

function ProfileAvatarRing ({
  avatarUrl,
  displayName,
  className = '',
}: ProfileAvatarRingProps) {
  return (
    <div className={`profile-avatar-ring${className ? ` ${className}` : ''}`}>
      <UserAvatar
        path={avatarUrl}
        className={['profile-avatar-ring__avatar']}
        name={displayName}
      />
    </div>
  )
}

export default React.memo(ProfileAvatarRing)
